export function friendlyError(error: string) {
  if (error.includes('non ISO-8859-1 code point') || error.includes('argument 2 to ByteString')) {
    return 'File name contains invalid characters';
  }

  return error;
}
